import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-shopping-cart-adhoc',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './shopping-cart-adhoc.component.html',
  styleUrl: './shopping-cart-adhoc.component.css'
})
export class ShoppingCartAdhocComponent {

}
